/**
 * CJSUSPENSION exact model-card CTA pairs.
 *
 * Button 1 = book the workshop service / installation for that exact item.
 * Button 2 = view the exact CJSUSPENSION product or parts range.
 *
 * This runs after custom.js and supplies specific CTA pairs when a model-card
 * master does not already provide the exact pair itself.
 */
(function () {
  'use strict';

  var BOOKING_URL = '/pages/book-a-suspension-service';

  function normalise(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function currentPath() {
    return String(window.location.pathname || '').toLowerCase();
  }

  function titleContains(title, value) {
    return normalise(title).indexOf(normalise(value)) !== -1;
  }

  function isFoxPage(path) {
    return path.indexOf('/pages/fox-') === 0;
  }

  function isRockShoxPage(path) {
    return path.indexOf('/pages/rockshox-') === 0;
  }

  function isMarzocchiPage(path) {
    return path.indexOf('/pages/marzocchi-') === 0;
  }

  function isDvoPage(path) {
    return path.indexOf('/pages/dvo-') === 0;
  }

  function isOhlinsPage(path) {
    return path.indexOf('/pages/ohlins-') === 0;
  }

  function smashpotProductUrl(path, title) {
    if (isRockShoxPage(path) || titleContains(title, 'rockshox')) {
      return '/products/rockshox-smashpot-fork-coil-conversion-system';
    }

    if (
      isFoxPage(path) ||
      isMarzocchiPage(path) ||
      titleContains(title, 'fox') ||
      titleContains(title, 'marzocchi')
    ) {
      return '/products/rockshox-vorsprung-smashpot-fork-coil-conversion-system';
    }

    if (isDvoPage(path) || titleContains(title, 'dvo')) {
      return '/products/dvo-smashpot-fork-coil-conversion-system';
    }

    if (
      isOhlinsPage(path) ||
      titleContains(title, 'ohlins') ||
      titleContains(title, 'öhlins')
    ) {
      return '/products/ohlins-smashpot-fork-coil-conversion-system';
    }

    return '';
  }

  function luftkappeProductUrl(path, title) {
    if (isRockShoxPage(path) || titleContains(title, 'rockshox')) {
      return '/products/vorsprung-rockshox-luftkappe-kits';
    }

    if (
      isFoxPage(path) ||
      isMarzocchiPage(path) ||
      titleContains(title, 'fox') ||
      titleContains(title, 'marzocchi')
    ) {
      return '/products/vorsprung-luftkappe';
    }

    return '';
  }

  function fixFractiveCardCopy(card, path) {
    if (!isFoxPage(path)) {
      return;
    }

    var heading = card.querySelector('h3');
    if (!heading || normalise(heading.textContent).indexOf('fractive') === -1) {
      return;
    }

    heading.textContent = 'Fractive Damper Tuning';

    var intro = card.querySelector('p');
    if (intro) {
      intro.textContent = 'Upgrade a compatible FOX FIT4 damper with Vorsprung Fractive compression tuning, professionally installed and tuned to suit the rider, bike and riding requirements.';
    }

    var list = card.querySelector('ul');
    if (list) {
      var bullets = [
        'Rider weight, bike and riding requirements reviewed',
        'Correct Fractive tune selected',
        'Fork damper inspected and assessed',
        'Damper stripped and cleaned',
        'Fractive compression piston and valving installed',
        'Damper serviced with fresh oil and seals as required',
        'Damper rebuilt and function checked',
        'Baseline settings supplied'
      ];

      list.textContent = '';
      bullets.forEach(function (text) {
        var item = document.createElement('li');
        item.textContent = text;
        list.appendChild(item);
      });
    }
  }

  function getConfig(title, path) {
    var text = normalise(title);

    if (text.indexOf('smashpot') !== -1) {
      var smashpotUrl = smashpotProductUrl(path, title);
      if (!smashpotUrl) {
        return null;
      }

      return {
        primaryLabel: 'Book 100hr & Smashpot Coil Conversion Kit',
        primaryUrl: BOOKING_URL,
        secondaryLabel: 'View Smashpot',
        secondaryUrl: smashpotUrl
      };
    }

    if (text.indexOf('secus') !== -1) {
      return {
        primaryLabel: 'Book 100hr & Secus Air Spring Upgrade',
        primaryUrl: BOOKING_URL,
        secondaryLabel: 'View Secus',
        secondaryUrl: '/products/secus-fork-air-spring-upgrade-kit-fox-rockshox-forks'
      };
    }

    if (text.indexOf('luftkappe') !== -1) {
      var luftkappeUrl = luftkappeProductUrl(path, title);
      if (!luftkappeUrl) {
        return null;
      }

      return {
        primaryLabel: 'Book 100hr & Luftkappe Air Piston Upgrade',
        primaryUrl: BOOKING_URL,
        secondaryLabel: 'View Luftkappe',
        secondaryUrl: luftkappeUrl
      };
    }

    if (text.indexOf('fractive') !== -1) {
      return {
        primaryLabel: 'Book 100hr + Fractive Tuning',
        primaryUrl: BOOKING_URL,
        secondaryLabel: 'View Fractive',
        secondaryUrl: '/pages/vorsprung-fractive'
      };
    }

    if (text.indexOf('tractive') !== -1) {
      return {
        primaryLabel: 'Book 100hr & Tractive Tuning',
        primaryUrl: BOOKING_URL,
        secondaryLabel: 'View Tractive',
        secondaryUrl: '/products/tractive-upgrade-kit'
      };
    }

    if (text.indexOf('brain 2.0') !== -1 && (text.indexOf('ifp') !== -1 || text.indexOf('floating piston') !== -1)) {
      return {
        primaryLabel: 'Book 100hr & Brain 2.0 IFP Upgrade',
        primaryUrl: BOOKING_URL,
        secondaryLabel: 'View Brain 2.0 IFP Upgrade',
        secondaryUrl: '/products/rockshox-brain-2-0-bladder-to-floating-piston'
      };
    }

    if (text.indexOf('lsc adjuster') !== -1) {
      return {
        primaryLabel: 'Book LSC Adjuster Upgrade',
        primaryUrl: BOOKING_URL,
        secondaryLabel: 'View LSC Adjuster',
        secondaryUrl: '/products/fox-upgrade-lsc-adjuster-2022-float-x-and-dhx'
      };
    }

    if (text.indexOf('bump stop') !== -1) {
      return {
        primaryLabel: 'Book 100hr & Bump Stop Upgrade',
        primaryUrl: BOOKING_URL,
        secondaryLabel: 'View Bump Stops',
        secondaryUrl: '/products/bump-stops'
      };
    }

    if (text.indexOf('split preload collar') !== -1) {
      return {
        primaryLabel: isRockShoxPage(path) ? 'Book Preload Collar Installation' : 'Book 100hr & Preload Collar Installation',
        primaryUrl: BOOKING_URL,
        secondaryLabel: 'View Preload Collars',
        secondaryUrl: '/products/fluid-focus-coil-rear-shock-split-preload-collar-kit'
      };
    }

    // Bomber CR already has a dedicated master metaobject with its exact two
    // buttons. Leave a complete master pair untouched.
    if (text.indexOf('bomber cr') !== -1 && (text.indexOf('piston kit') !== -1 || text.indexOf('tuning kit') !== -1)) {
      return {
        primaryLabel: 'Book 100hr Service & Tuning Kit',
        primaryUrl: BOOKING_URL,
        secondaryLabel: 'View Tuning Kits',
        secondaryUrl: '/products/fluid-focus-marzocchi-rear-shock-piston-kits',
        respectMasterPair: true
      };
    }

    if (text.indexOf('fluid focus') !== -1) {
      // Float X and DHX use their own Timely-only Fluid Focus tuning-kit add-ons.
      // Do not point either card at a different retail piston-kit product.
      if (path === '/pages/fox-float-x' || path === '/pages/fox-dhx') {
        return null;
      }

      // Float X2 / DHX2 use the specific rear-shock piston-kit product.
      if (isFoxPage(path) && (path === '/pages/fox-float-x2' || path === '/pages/fox-dhx2')) {
        return {
          primaryLabel: 'Book 100hr & Fluid Focus Tuning Kit',
          primaryUrl: BOOKING_URL,
          secondaryLabel: 'View Fluid Focus Tuning Kit',
          secondaryUrl: '/products/shox-performance-tuning-kits'
        };
      }

      if (isRockShoxPage(path)) {
        return {
          primaryLabel: 'Book 100hr & Fluid Focus Tuning Kit',
          primaryUrl: BOOKING_URL,
          secondaryLabel: 'View Fluid Focus Tuning Kit',
          secondaryUrl: '/products/tuning-kits'
        };
      }

      // Remaining supported Fox Fluid Focus cards are fork damper/piston kits.
      if (isFoxPage(path) && (text.indexOf('fork') !== -1 || text.indexOf('grip') !== -1 || text.indexOf('damper') !== -1)) {
        return {
          primaryLabel: 'Book 100hr & Fluid Focus Tuning Kit',
          primaryUrl: BOOKING_URL,
          secondaryLabel: 'View Fluid Focus Tuning Kit',
          secondaryUrl: '/products/fluid-focus-fox-fork-damper-high-flow-piston-re-valve-kits'
        };
      }
    }

    if (text.indexOf('lower leg bushing replacement') !== -1) {
      return {
        primaryLabel: 'Book Lower Leg Bushing Replacement',
        primaryUrl: BOOKING_URL,
        secondaryLabel: 'View Fork Bushings',
        secondaryUrl: '/collections/fork-bushings'
      };
    }

    if (text.indexOf('steerer tube replacement') !== -1 || text.indexOf('tapered steerer replacement') !== -1) {
      return {
        primaryLabel: 'Book Steerer Replacement',
        primaryUrl: BOOKING_URL,
        secondaryLabel: 'View Steerer Tubes',
        secondaryUrl: '/products/steerer-tube-fork'
      };
    }

    if (text.indexOf('scratch repair') !== -1) {
      return {
        primaryLabel: 'Book Scratch Repair',
        primaryUrl: BOOKING_URL,
        secondaryLabel: 'View Scratch Repair Kits',
        secondaryUrl: '/products/scratch-cover-repair-kits'
      };
    }

    return null;
  }

  function actionContainer(card, primary) {
    var actions = card.querySelector('.cjs-model-upgrade-actions');
    if (actions) {
      return actions;
    }

    actions = document.createElement('div');
    actions.className = 'cjs-model-upgrade-actions cjs-model-store-actions';

    if (primary && primary.parentNode === card) {
      card.insertBefore(actions, primary);
      actions.appendChild(primary);
    } else {
      card.appendChild(actions);
    }

    return actions;
  }

  function wireCard(card) {
    var heading = card.querySelector('h3');
    if (!heading) {
      return;
    }

    var path = currentPath();
    fixFractiveCardCopy(card, path);

    heading = card.querySelector('h3');
    var config = getConfig(heading.textContent, path);
    if (!config) {
      return;
    }

    var buttons = card.querySelectorAll('a.cjs-model-button');
    var primary = buttons.length ? buttons[0] : null;
    var secondary = buttons.length > 1 ? buttons[1] : null;

    if (config.respectMasterPair && primary && secondary && !secondary.hasAttribute('data-cjs-store-secondary')) {
      return;
    }

    var actions = actionContainer(card, primary);

    if (!primary) {
      primary = document.createElement('a');
      primary.className = 'cjs-model-button';
      actions.appendChild(primary);
    }

    primary.href = config.primaryUrl;
    primary.textContent = config.primaryLabel;
    primary.setAttribute('data-cjs-exact-primary', '');

    if (!secondary) {
      secondary = document.createElement('a');
      secondary.className = 'cjs-model-button secondary';
      actions.appendChild(secondary);
    }

    secondary.href = config.secondaryUrl;
    secondary.textContent = config.secondaryLabel;
    secondary.classList.add('secondary');
    secondary.setAttribute('data-cjs-exact-secondary', '');
  }

  function upgradePriority(card) {
    var label = card.querySelector('.cjs-model-upgrade-label, .cjs-brand-performance-upgrades__label');
    var heading = card.querySelector('h3');
    var labelText = normalise(label ? label.textContent : '');
    var headingText = normalise(heading ? heading.textContent : '');
    var combined = labelText + ' ' + headingText;

    if (
      labelText === 'vorsprung' ||
      combined.indexOf('vorsprung') !== -1 ||
      /smashpot|secus|luftkappe|fractive|tractive/.test(combined)
    ) {
      return 0;
    }

    if (
      labelText === 'fluid focus' ||
      combined.indexOf('fluid focus') !== -1
    ) {
      return 1;
    }

    return 2;
  }

  function isUpgradeCardForGrid(card, grid) {
    if (!card.classList) return false;

    if (grid.classList.contains('cjs-model-upgrade-grid')) {
      return card.classList.contains('cjs-model-upgrade-card');
    }

    if (grid.classList.contains('cjs-brand-performance-upgrades__grid')) {
      return card.classList.contains('cjs-brand-performance-upgrades__card');
    }

    return false;
  }

  function prioritisePerformanceUpgrades() {
    var grids = document.querySelectorAll(
      '.cjs-model-upgrade-grid, .cjs-brand-performance-upgrades__grid'
    );

    grids.forEach(function (grid) {
      var cards = Array.prototype.slice.call(grid.children).filter(function (child) {
        return isUpgradeCardForGrid(child, grid);
      });

      if (cards.length < 2) {
        return;
      }

      var desired = cards
        .map(function (card, index) {
          return {
            card: card,
            index: index,
            priority: upgradePriority(card)
          };
        })
        .sort(function (a, b) {
          if (a.priority !== b.priority) {
            return a.priority - b.priority;
          }

          return a.index - b.index;
        })
        .map(function (item) {
          return item.card;
        });

      var needsReorder = desired.some(function (card, index) {
        return cards[index] !== card;
      });

      if (!needsReorder) {
        return;
      }

      desired.forEach(function (card) {
        grid.appendChild(card);
      });
    });
  }

  function run() {
    var cards = document.querySelector('.cjs-model-card, .cjs-model-upgrade-card');
    if (cards) {
      document.querySelectorAll('.cjs-model-card, .cjs-model-upgrade-card').forEach(wireCard);
    }

    prioritisePerformanceUpgrades();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  var observer = new MutationObserver(function () {
    observer.disconnect();
    run();
    observer.observe(document.documentElement, { childList: true, subtree: true });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
